import { useContext } from 'react';
import { TranscriptRedactingContext } from '@/containers/Transcript.Redaction/Context';

export const useTranscriptRedactingContext = () => {
  return useContext(TranscriptRedactingContext);
};